import { render } from "./PortalShell.vue?vue&type=template&id=0a7bca38&scoped=true&ts=true&lang=pug"
import script from "./PortalShell.vue?vue&type=script&lang=ts"
export * from "./PortalShell.vue?vue&type=script&lang=ts"

import "./PortalShell.vue?vue&type=style&index=0&id=0a7bca38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7bca38"]])

export default __exports__